import './loader.scss';

function Loader({
    show
} : {
    show: boolean
}) {
    return (
        <div id="loader" className={`${show ? 'open' : ''}`}>
            <i className="fal fa-spinner fa-spin"></i>
        </div>
    )
}

export default Loader;